import React from 'react'
import PropTypes from 'prop-types'

import { IS_PROPERTY } from 'Config/config'
import AppLink from 'Components/AppLink'
import { BuildingAmenities } from 'Components'

import {
  _BuildingBanner, _BuildingImage, _BuildingCopy, _ListingAmenitiesContainer,
  _ListingCounts, _Divider, _Title, _AddressName,
} from './styles.js'

const ListingAmenities = ({ listing, collapsibleIdSuffix, googleAnalyticsEvent }) => {
  const { amenities, maintenances, building } = listing || {}
  const {
    name: buildingName, main_photo: photo,
    listings_for_rent_count: rentCount,
    listings_for_sale_count: saleCount,
    address_name: addressName, url,
  } = building || {}

  if((amenities && amenities.length) || (maintenances && maintenances.length)) {
    return (
      <_ListingAmenitiesContainer>
        <BuildingAmenities
          inputId={`Amenities-${collapsibleIdSuffix}`}
          collapsibleTitle={'Amenities'}
          title={buildingName || listing.title}
          amenities={amenities}
          maintenances={maintenances}
          gaSource="listing"
          googleAnalyticsEvent={googleAnalyticsEvent}
        />
        {
          !IS_PROPERTY && url &&
            <_BuildingBanner>
              <_BuildingImage src={photo} alt={buildingName} width={640} height={480} />
              <_BuildingCopy>
                <_Title>
                  <AppLink
                    alt={buildingName}
                    to={'/' + url}
                  >
                    {buildingName}
                  </AppLink>
                </_Title>
                {
                  addressName && (
                    <_AddressName>
                      {addressName}
                    </_AddressName>
                  )
                }
                <_ListingCounts>
                  <div>For sale <span>{saleCount}</span></div>
                  <_Divider>|</_Divider>
                  <div>For rent <span>{rentCount}</span></div>
                </_ListingCounts>
              </_BuildingCopy>
            </_BuildingBanner>
        }

      </_ListingAmenitiesContainer>
    )
  }
  return null
}


ListingAmenities.propTypes = {
  listing: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    property_type: PropTypes.string,
  }),
  collapsibleIdSuffix: PropTypes.string,
  googleAnalyticsEvent: PropTypes.func,
}

export default ListingAmenities
